module.exports = "<div id=\"onlineBilling\">\n    <billing-summary></billing-summary>\n    <billing-preview></billing-preview>\n    <billing-payment-history></billing-payment-history>\n</div>";


//////////////////
// WEBPACK FOOTER
// ./modules/billing/components/billing-overview/billingOverview.component.html
// module id = 506
// module chunks = 0